import React, { useCallback } from 'react';
import { CrmActivityMeeting } from './icons/CrmActivityMeeting.component';
import { CrmActivityNote } from './icons/CrmActivityNote.component';
import { CrmActivityCallIcon } from './icons/CrmActivityCall.component';
import { CrmActivityTask } from './icons/CrmActivityTask.component';
import classnames from 'classnames';
import { theme } from '../../../../../tailwind.config';
import { ECrmActivityType } from 'services/CrmApi/types/CrmActivityTypes';

interface ICrmActivityTypeButtonProps {
  type: ECrmActivityType;
  onClick: () => void;
  disabled?: boolean;
}

export const CrmActivityTypeButton: React.FC<ICrmActivityTypeButtonProps> = ({ type, onClick, disabled }) => {
  const labelMapping = {
    [ECrmActivityType.CALL]: 'Call',
    [ECrmActivityType.MEETING]: 'Meeting',
    [ECrmActivityType.NOTE]: 'Note',
    [ECrmActivityType.TASK]: 'Task',
  };
  const label = labelMapping[type];
  const iconMapping = {
    [ECrmActivityType.CALL]: CrmActivityCallIcon,
    [ECrmActivityType.MEETING]: CrmActivityMeeting,
    [ECrmActivityType.NOTE]: CrmActivityNote,
    [ECrmActivityType.TASK]: CrmActivityTask,
  };
  const Icon = iconMapping[type];
  const fill = disabled ? theme.colors['gray-40'] : undefined;
  const background = disabled ? theme.colors['gray-20'] : undefined;
  const labelClassname = classnames('font-pt-sans text-[15px] capitalize', {
    'text-brown-100 underline': !disabled,
    'text-gray-40': disabled,
  });

  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }
    onClick && onClick();
  }, [onClick, disabled]);

  return (
    <div className="activity-type-button cursor-pointer flex flex-col gap-[5px] items-center" onClick={handleClick}>
      <Icon fill={fill} background={background} />
      <span className={labelClassname}>{label}</span>
    </div>
  );
};
